<template>
  <b-button inline-block class="cancel-btn" v-on:click="onClick">{{ label }}</b-button>
</template>

<style scoped>
.cancel-btn {
  background-color: #8ca6b7;
  border-color: #8ca6b7;
  width: 167px;
  height: 42px;
  font-size: 16px;
  font-weight: bold;
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "cancel",
  props: {
    label: { type: String, default: "キャンセル", required: true },
  },
  setup(_props, { emit }) {
    const onClick = (): void => {
      emit("cancel");
    };
    return { onClick };
  },
});
</script>
